import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';
import InputFilter from '../../../Filters/InputFilter';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import {RouterTwoTone} from '@mui/icons-material';

function PA({
    editarProposta,
    marcas,
    tipoContrato,
    setTipoContrato,
    arrayTipoContrato,
    lubrificantes,
    setLubrificantes,
    arrayLubrificantes,
    duracaoContrato,
    setDuracaoContrato,
    arrayDuracaoContrato,
    arrayHorasAno,
    horasAno,
    setHorasAno,
    precoHora,
    setPrecoHora,
    setOnChangeForm,
    arrayPontosAnalise,
    setPontosAnalise,
    pontosAnalise,
}) {
    const {t} = useTranslation();
    useEffect(() => {
        if (pontosAnalise?.length == 0 || pontosAnalise == undefined) {
            setPontosAnalise([
                {
                    id: Math.floor(Math.random() * 999999),
                    pAnalise: null,
                    precoBruto: 0,
                },
            ]);
        }
    }, []);

    const rowCount = pontosAnalise?.length;

    function eliminarLinha(id) {
        setPontosAnalise(pontosAnalise?.filter(l => l.id !== id));
    }

    function adicionarLinha(id) {
        setPontosAnalise([
            ...pontosAnalise,
            {
                id: Math.floor(Math.random() * 999999),
                pAnalise: null,
                precoBruto: 0,
            },
        ]);
    }

    const handleChildChange = (e, id) => {
        const updatedData = [...pontosAnalise];
        updatedData[id] = e;
        setPontosAnalise(updatedData);
    };

    return (
        <div>
            <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                        <tr>
                            <th scope="col" className="px-6 py-3 ">
                                {t('paCalculo')}
                            </th>
                            {/* <th scope="col" className="px-6 py-3 w-[50%]">
                                {t('descricao')}
                            </th> */}
                            <th scope="col" className="px-6 py-3 text-end w-80">
                                {t('precoBruto')}
                            </th>

                            <th scope="col" className="px-6 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {pontosAnalise?.map((row, rowIndex) => {
                            return (
                                <tr
                                    key={rowIndex}
                                    className="bg-white border-b cursor-pointer dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 items-center"
                                    //   onClick={() => handleRowClick(dados)}
                                >
                                    <td className="px-6 py-4">
                                        <SelectComponent
                                            options={arrayPontosAnalise}
                                            value={row.pAnalise}
                                            onChange={e => {
                                                row.pAnalise = e;
                                                handleChildChange(row, rowIndex);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('selecioneOpcao')}
                                            isDisabled={!editarProposta}
                                        />
                                    </td>

                                    {/* <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.modelo}
                                            placeholder={t('descricao')}
                                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                            onChange={e => {
                                                row.modelo = e.target.value;
                                                handleChildChange(row, rowIndex);
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td> */}

                                    <td className="px-6 py-4 text-end w-80">
                                        <input
                                            type="number"
                                            value={row.precoBruto}
                                            placeholder={t('valor')}
                                            className="block w-80 text-end text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                            onChange={e => {
                                                row.precoBruto = Number(e.target.value);
                                                handleChildChange(row, rowIndex);
                                            }}
                                            disabled={!editarProposta}
                                        />
                                    </td>
                                    <td className="px-2 py-4">
                                        {rowCount === rowIndex + 1 && row.marca !== '' && row.categoria !== '' && editarProposta && (
                                            <button className={`mt-2 rounded-full p-1 ${'bg-blue-600'} text-white`}>
                                                <AddRoundedIcon onClick={adicionarLinha} />
                                            </button>
                                        )}
                                        {rowCount != rowIndex + 1 && editarProposta && (
                                            <button
                                                onClick={e => {
                                                    eliminarLinha(row.id);
                                                    e.preventDefault();
                                                }}
                                                className={`mt-2 rounded-full p-1 ${'bg-red-600'} text-white`}>
                                                <DeleteForeverRoundedIcon />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default PA;
